import React, { createContext } from 'react';
import useAuth from './Hooks/useAuth';
import materialComunicacao from './Hooks/materialComunicacao';
import etapa from './Hooks/etapa';
import regional from './Hooks/regional';
import motivo from './Hooks/motivo';
import solicitante from './Hooks/solicitante';

const Context = createContext();

const AuthProvider = ({ children }) => {
  const {
    showLoader,
    handleLogin,
    handleLogout,
    userData,
    setUserData,
    adminLoginAs,
    loginWithToken,
  } = useAuth();

  const { getMaterialComunicacaoSelectList } = materialComunicacao();

  const { getEtapaSelectList } = etapa();

  const { getRegionalSelectListFilhas } = regional();

  const { getMotivoSelectList } = motivo();

  const { getSolicitanteSelectList } = solicitante();

  return (
    <Context.Provider
      value={{
        showLoader,
        handleLogin,
        handleLogout,
        getMaterialComunicacaoSelectList,
        getEtapaSelectList,
        getRegionalSelectListFilhas,
        getMotivoSelectList,
        getSolicitanteSelectList,
        userData,
        setUserData,
        adminLoginAs,
        loginWithToken,
      }}
    >
      {children}
    </Context.Provider>
  );
};

export { Context, AuthProvider };
